import React, { useEffect, useState } from 'react';

import { StyledToggleHeading, Typography, Wrapper } from '@pkg/components';
import { TruncatedValue } from '@pkg/components/Sections/Admin/Users/styles';

import { type LootBox, type LootBoxType } from '@app/client';
import { decimals } from '@app/helpers';

interface LootBoxMgmtTableProps {
    lootBoxes: LootBox[];
    onDelete: (id: string) => void;
    onSelected: (id: string, field: string) => void;
    onFilterLootBoxes: (id: string) => void;
    lootBoxTypes: LootBoxType[];
    currentTypeId?: string;
}

const LootBoxMgmtTable = ({
    lootBoxes,
    onDelete,
    lootBoxTypes,
    onSelected,
    currentTypeId = 'all',
    onFilterLootBoxes,
}: LootBoxMgmtTableProps) => {
    const [currentLootBoxes, setCurrentLootBoxes] = useState<LootBox[]>(lootBoxes);
    const [showLootBoxes, setShowLootBoxes] = useState<boolean>(true);

    useEffect(() => {
        if (lootBoxes && lootBoxes.length > 0) {
            setCurrentLootBoxes(lootBoxes);
        } else {
            setCurrentLootBoxes([]);
        }
    }, [lootBoxes]);

    return (
        <Wrapper>
            <StyledToggleHeading type="button" onClick={() => setShowLootBoxes((c) => !c)}>
                <Typography type="headline" size={20}>
                    Manage Prism Cases +
                </Typography>
            </StyledToggleHeading>
            {showLootBoxes && (
                <Wrapper>
                    <label htmlFor="types">Filter by Lootbox type:</label>
                    <select
                        className="lbt-select"
                        value={currentTypeId}
                        name="types"
                        id="types"
                        onChange={(e) => onFilterLootBoxes(e.target.value)}
                    >
                        <option value={'all'} className="lbt-option">
                            All
                        </option>
                        {lootBoxTypes.map((lbt, i) => {
                            return (
                                <option key={i} className="lbt-option" value={lbt.id}>
                                    {lbt.name}
                                </option>
                            );
                        })}
                    </select>
                    <table key={lootBoxes.length} className="lb-table">
                        <tbody>
                            <tr key="lb" className="row-header type main">
                                <td>ID</td>
                                <td>lootbox type </td>
                                <td>yats</td>
                                <td>scores</td>
                                <td>prices</td>
                                <td>total value</td>
                                <td>owner ID</td>
                                <td>average rhythm score</td>
                                <td>created at</td>
                                <td>status</td>
                                <td>Del</td>
                            </tr>
                            {currentLootBoxes.map((box, i) => {
                                const lbtName = lootBoxTypes.find((lbt) => lbt.id === box.lootbox_type_id)?.name;
                                return (
                                    <tr key={i} className="type">
                                        <td>
                                            <TruncatedValue $maxWidth={80} title={box.id}>
                                                {box.id}
                                            </TruncatedValue>
                                        </td>
                                        <td>{lbtName}</td>
                                        <td>
                                            <table className="lb-table sub-table">
                                                <tbody>
                                                    <tr className="type">
                                                        <td>
                                                            {box.yats.map((y, i) => {
                                                                return (
                                                                    <div className="sublist" key={i}>
                                                                        {y}
                                                                    </div>
                                                                );
                                                            })}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>
                                            <table className="lb-table sub-table">
                                                <tbody>
                                                    <tr className="type">
                                                        <td>
                                                            {box.scores.map((s, i) => {
                                                                return (
                                                                    <div className="sublist" key={i}>
                                                                        {s}
                                                                    </div>
                                                                );
                                                            })}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>

                                        <td>
                                            <table className="lb-table sub-table">
                                                <tbody>
                                                    <tr className="type">
                                                        <td>
                                                            {box.prices.map((p, i) => {
                                                                return (
                                                                    <div className="sublist" key={i}>
                                                                        {`$${decimals(p / 100)}`}
                                                                    </div>
                                                                );
                                                            })}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>{box.total_value}</td>
                                        <td onClick={() => onSelected(box.id, 'owner')} className="clickable">
                                            <TruncatedValue $maxWidth={100} title={box.owner_id} $cursor="pointer">
                                                {box.owner_id}
                                            </TruncatedValue>
                                        </td>
                                        <td>{decimals(box.average_rhythm_score)}</td>
                                        <td>{box.created_at}</td>
                                        <td>{box.status}</td>

                                        <td width={15} className="align-mid">
                                            <img
                                                src="/assets/icons/close-icon.svg"
                                                alt=""
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onDelete(box.id);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Wrapper>
            )}
        </Wrapper>
    );
};

export default LootBoxMgmtTable;
